"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Phaser = require("phaser");
const gamecontroller_ts_1 = require("../gamecontroller.ts");
var lvl1, lvl2, lvl3, lvl4, lvl5, lvl6, lvl7, lvl8, lvl9, lvl10, lvl11, lvl12, lvl13;
var resetbutton;
var mainMenuButton;
var farbschema_klein;
var lvlziel;
class BootState extends Phaser.State {
    init() {
        this.stage.backgroundColor = '#FFF';
    }
    preload() {
        this.game.load.image('tiles', 'assets/gridtiles_final.png');
        this.game.load.image('farbschema_klein', 'assets/images/farbschema_klein.png');
        this.game.load.spritesheet('button', 'assets/images/menu_button.png', 0, 71);
        this.game.load.tilemap('map4', 'assets/maps/3x3_1xRot_1xGelb_1xBlau.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map1', 'assets/maps/3x3_1xRot_tut.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map3', 'assets/maps/3x3_1xRot.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map2', 'assets/maps/3x3_1xSchwarz_tut.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map5', 'assets/maps/3x3_2j.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map6', 'assets/maps/3x3_2xBlau.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map7', 'assets/maps/3x3_2xGruen.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map8', 'assets/maps/3x3_3j.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map9', 'assets/maps/3x3_j1.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map10', 'assets/maps/4x4_1j.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map11', 'assets/maps/4x4_2j.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map12', 'assets/maps/4x4_3j.json', null, Phaser.Tilemap.TILED_JSON);
        this.game.load.tilemap('map13', 'assets/maps/4x4_4j.json', null, Phaser.Tilemap.TILED_JSON);
    }
    create() {
        this.mainMenu();
        mainMenuButton = this.game.add.button(this.game.world.centerX - 320, 500, 'button', this.actionOnClick, this, 2, 1, 0);
        //farbschema_klein = this.game.add.sprite(this.game.world.centerX -300,350, 'farbschema_klein');
    }
    actionOnClick() {
        window.location.reload();
    }
    mainMenu() {
        // = this.game.add.image("farbschema",)
        farbschema_klein = this.game.add.sprite(this.game.world.centerX - 300, 300, 'farbschema_klein');
        farbschema_klein.scale.setTo(0.25);
        lvl1 = this.game.add.text(320, 20, 'Level 1', { fill: '#000000' });
        lvl1.inputEnabled = true;
        lvl1.events.onInputDown.add(this.loadLevel1, this);
        lvl2 = this.game.add.text(320, 60, 'Level 2', { fill: '#000000' });
        lvl2.inputEnabled = true;
        lvl2.events.onInputDown.add(this.loadLevel2, this);
        lvl3 = this.game.add.text(320, 100, 'Level 3', { fill: '#000000' });
        lvl3.inputEnabled = true;
        lvl3.events.onInputDown.add(this.loadLevel3, this);
        lvl4 = this.game.add.text(320, 140, 'Level 4', { fill: '#000000' });
        lvl4.inputEnabled = true;
        lvl4.events.onInputDown.add(this.loadLevel4, this);
        lvl5 = this.game.add.text(320, 180, 'Level 5', { fill: '#000000' });
        lvl5.inputEnabled = true;
        lvl5.events.onInputDown.add(this.loadLevel5, this);
        lvl6 = this.game.add.text(320, 220, 'Level 6', { fill: '#000000' });
        lvl6.inputEnabled = true;
        lvl6.events.onInputDown.add(this.loadLevel6, this);
        lvl7 = this.game.add.text(320, 260, 'Level 7', { fill: '#000000' });
        lvl7.inputEnabled = true;
        lvl7.events.onInputDown.add(this.loadLevel7, this);
        lvl8 = this.game.add.text(320, 300, 'Level 8', { fill: '#000000' });
        lvl8.inputEnabled = true;
        lvl8.events.onInputDown.add(this.loadLevel8, this);
        lvl9 = this.game.add.text(320, 340, 'Level 9', { fill: '#000000' });
        lvl9.inputEnabled = true;
        lvl9.events.onInputDown.add(this.loadLevel9, this);
        lvl10 = this.game.add.text(320, 380, 'Level 10', { fill: '#000000' });
        lvl10.inputEnabled = true;
        lvl10.events.onInputDown.add(this.loadLevel10, this);
        lvl11 = this.game.add.text(320, 420, 'Level 11', { fill: '#000000' });
        lvl11.inputEnabled = true;
        lvl11.events.onInputDown.add(this.loadLevel11, this);
        lvl12 = this.game.add.text(320, 460, 'Level 12', { fill: '#000000' });
        lvl12.inputEnabled = true;
        lvl12.events.onInputDown.add(this.loadLevel12, this);
        lvl13 = this.game.add.text(320, 500, 'Level 13', { fill: '#000000' });
        lvl13.inputEnabled = true;
        lvl13.events.onInputDown.add(this.loadLevel13, this);
    }
    loadLevel1() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map1');
        this.gameController.level = 1;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 1', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel1, this);
        lvlziel = this.game.add.text(30, 150, 'Tutorial zum Erzeugen von 1x Rot', { fill: '#000000' });
    }
    loadLevel2() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map2');
        this.gameController.level = 2;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 2', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel2, this);
        lvlziel = this.game.add.text(30, 150, 'Tutorial zum Erzeugen von 1x Schwarz', { fill: '#000000' });
    }
    loadLevel3() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map3');
        this.gameController.level = 3;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 3', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel3, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 1x Rot', { fill: '#000000' });
    }
    loadLevel4() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map4');
        this.gameController.level = 4;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 4', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel4, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 1x Rot 1x Gelb 1x Blau', { fill: '#000000' });
    }
    loadLevel5() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map6');
        this.gameController.level = 6;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 5', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel5, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 2x Blau', { fill: '#000000' });
    }
    loadLevel6() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map7');
        this.gameController.level = 7;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 6', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel6, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 2x Grün', { fill: '#000000' });
    }
    loadLevel7() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map5');
        this.gameController.level = 5;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 7', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel7, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 2x Schwarz', { fill: '#000000' });
    }
    loadLevel8() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map8');
        this.gameController.level = 8;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 8', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel8, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 3x Schwarz', { fill: '#000000' });
    }
    loadLevel9() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map9');
        this.gameController.level = 9;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 9', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel9, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 3x Schwarz', { fill: '#000000' });
    }
    loadLevel10() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map10');
        this.gameController.level = 10;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 10', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel10, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 5x Schwarz', { fill: '#000000' });
    }
    loadLevel11() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map11');
        this.gameController.level = 11;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 11', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel11, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 4x Schwarz', { fill: '#000000' });
    }
    loadLevel12() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map12');
        this.gameController.level = 12;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 12', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel12, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 4x Schwarz', { fill: '#000000' });
    }
    loadLevel13() {
        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.gameController = new gamecontroller_ts_1.GameController(this.game);
        this.gameController.init('map13');
        this.gameController.level = 13;
        destroyLevelMenu();
        // clumpsy Resetbutton
        resetbutton = this.game.add.text(400, 20, 'Reset Level 13', { fill: '#000000' });
        resetbutton.inputEnabled = true;
        resetbutton.events.onInputDown.add(this.loadLevel13, this);
        lvlziel = this.game.add.text(30, 150, 'Erzeuge 3x Schwarz', { fill: '#000000' });
    }
}
exports.BootState = BootState;
function destroyLevelMenu() {
    lvl1.destroy();
    lvl2.destroy();
    lvl3.destroy();
    lvl4.destroy();
    lvl5.destroy();
    lvl6.destroy();
    lvl7.destroy();
    lvl8.destroy();
    lvl9.destroy();
    lvl10.destroy();
    lvl11.destroy();
    lvl12.destroy();
    lvl13.destroy();
}



//////////////////
// WEBPACK FOOTER
// ./src/states/boot.ts
// module id = 3
// module chunks = 0